import { Component, Input } from '@angular/core';
import { ClickOutsideDirective } from '../../directive/click-outside.directive';

@Component({
  selector: 'app-table-action-buttons',
  standalone: true,
  imports: [ClickOutsideDirective],
  templateUrl: './table-action-buttons.component.html',
  styleUrl: './table-action-buttons.component.scss'
})
export class TableActionButtonsComponent {
  @Input() id: number;

  public dropdownState: { [key: number]: boolean } = {};


  clickOutside(id: number) {
    this.dropdownState[id] = false;
  }

  toggleDropdown(id: number) {
    this.dropdownState[id] = !this.dropdownState[id];
  }
}
